import React from 'react'
import moment from 'moment-timezone'
import { compact } from 'lodash'

import { Link } from 'core'
import { SUBTYPE_LABELS, linkTo } from 'event-taxonomy'

import css from './style.scss'

/**
 * A single event inside a day cell. Rendered as a real link so tab order and
 * screen-reader announcement come for free, with a visually hidden prefix so
 * the title still makes sense read out of context.
 */
const CalendarEventChip = ({ event }) => {
  const isDeadline = event.type === 'session_sale'
  const label = SUBTYPE_LABELS[event.target.type]
  const time = isDeadline ? null : moment(event.target.start_at).format('h:mma')

  // Deadlines get a visible "Registration ends" flag on the chip itself —
  // the orange color alone read as an event day rather than a cutoff, so a
  // hidden-only prefix wasn't enough to tell the two apart at a glance.
  const prefix = isDeadline
    ? null
    : compact([label, time]).join(', ') + ': '

  return (
    <li className={css.chipItem}>
      {/* target is ignored for internal react-router links (see
          EventListItem.js) — needed here so external/Zoom events open in a
          new tab instead of navigating the calendar away in-SPA. */}
      <Link to={linkTo(event)} target='_blank'>
        <span
          className={compact([
            css.chip,
            isDeadline ? css.chipDeadline : css.chipWebinar
          ]).join(' ')}
        >
          {prefix && <span className={css.visuallyHidden}>{prefix}</span>}
          {isDeadline && <span className={css.chipDeadlineLabel}>Registration ends</span>}
          {time && <span className={css.chipTime}>{time}</span>}
          <span className={css.chipTitle}>{event.target.title}</span>
        </span>
      </Link>
      {/* Custom tooltip rather than a native `title` attribute so it can be
        styled to match the site. Purely decorative — the link's own text
        already carries the full title for screen readers. */}
      <span className={css.chipTooltip} aria-hidden='true'>{event.target.title}</span>
    </li>
  )
}

CalendarEventChip.propTypes = {
  event: React.PropTypes.shape({
    type: React.PropTypes.oneOf(['webinar', 'session_sale']).isRequired,
    target: React.PropTypes.object.isRequired
  }).isRequired
}

export default CalendarEventChip
